<cc-lg-chart
  [useLegend]="false"
  [chartType]="'bar'"
  [chartsData]="chartsData"
  [options]="verticalBarChartOptions"
></cc-lg-chart>
